import './src/styles/global.css';
import React from 'react';
import Layout from './src/components/CyDWrappers/layout';
import { logAnalytics, initializeAnalytics } from './src/util';

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// Initialize analytics on client-side
export const onClientEntry = () => {
  // Skip during server-side rendering and run only in browser
  if (typeof window !== 'undefined') {
    // Initialize analytics
    initializeAnalytics();
  }
};

// Add automatic page view tracking
export const onRouteUpdate = ({ location, prevLocation }) => {
  const pagePath = location.pathname;
  const pageTitle = getPageTitle(pagePath);

  // Log page view event
  logAnalytics({
    category: 'page_view',
    action: 'page_view',
    label: pageTitle,
    parameters: {
      page_title: pageTitle,
      page_location: location.href,
      page_path: pagePath,
    },
  });
};

// Helper function to get page title based on path
function getPageTitle(path) {
  // Strip trailing slash if present
  const cleanPath = path.endsWith('/') ? path.slice(0, -1) : path;

  // Get the last segment of the path
  const pathSegments = cleanPath.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];

  // If it's the home page
  if (cleanPath === '') return 'Home';

  // Otherwise, capitalize the path segment and trim any whitespace
  return lastSegment
    .split('-')
    .map((word) => word.trim().charAt(0).toUpperCase() + word.trim().slice(1))
    .join(' ')
    .trim(); // Trim any extra spaces before and after
}
